import styled from 'styled-components'
import { colors } from '../../styles'

export const StyledSearschPanel = styled.div`
  background: ${colors.greyDark};
  border-radius: 4px;
  height: 32px;
  display: flex;
  align-items: center;
  padding-right: 4px;
  margin-right: 20px;

  & > .input-area {
    flex: 1;
  }

  .search-input {
    background: transparent;
    color: ${colors.grey40};
    width: 100%;
    border: 0;
    font-family: knowledge2017regular;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 12px;
    &:focus {
      color: ${colors.white};
    }
  }

  .search-button {
    background: ${colors.grey};
    border-radius: 4px;
    border: 0;
    color: ${colors.white};
    cursor: pointer;
    display: flex;
    padding: 2px 18px;
  }
`
